var map = {
	"./Amphenol.svg": 5870,
	"./Bekaert.svg": 9147,
	"./EPTV.png": 1304,
	"./EPTV.webp": 2169,
	"./LyondellBasell.png": 4092,
	"./belgo.svg": 3005,
	"./boldrini.svg": 4755,
	"./brasanitas.png": 5563,
	"./chicago.png": 2994,
	"./coppersteel.svg": 5905,
	"./cristalia.png": 1105,
	"./dayco.png": 6840,
	"./future.png": 2089,
	"./galderma.svg": 7889,
	"./ge.svg": 4853,
	"./gran.svg": 6961,
	"./kerry.png": 7655,
	"./mahle.png": 1670,
	"./neorodas.png": 5942,
	"./samsung.png": 2425,
	"./solubras.jpg": 7683,
	"./suominen.svg": 913
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8777;